import { useMeQuery } from '../../api/queries/me';

export const PersonalModeHeader = () => {
  const { data } = useMeQuery();
  const keyPairId = data?.user?.keyPairId;
  return (
    <div className="w-full flex items-center pb-6">
      {/* <Spacer />
      <ReactTooltip id="key" effect="solid" type="light" place="top" />
      {keyPairId && (
        <a
          className="text-xs"
          href={`${API_ENDPOINT}/tinker-boxes/keypair/${keyPairId}`}
          data-for="key"
          data-tip="Download keypair"
        >
          <FontAwesomeIcon icon={faKey} />
        </a>
      )} */}
    </div>
  );
};
